import { Link } from 'react-router-dom';
import { frankfurtArticle } from '@/mocks/frankfurt2026';

export default function ArticleHero() {
  return (
    <section className="relative w-full overflow-hidden bg-navy-900">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-1/3 w-[520px] h-[520px] bg-gold-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-[420px] h-[420px] bg-navy-400/20 rounded-full blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-8 pt-10 pb-14 md:pt-14 md:pb-20">
        <div className="max-w-6xl mx-auto">
          <nav className="flex items-center gap-2 text-xs text-cream-200/70 mb-8 flex-wrap">
            <Link to="/events" className="hover:text-gold-300 transition-colors duration-300 whitespace-nowrap">
              Events
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gold-300 whitespace-nowrap">Frankfurt Book Fair 2026</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-gold-500/15 border border-gold-400/30 rounded-full mb-6">
                <i className="ri-book-2-line text-gold-400 text-xs"></i>
                <span className="text-[11px] font-medium text-gold-300 uppercase tracking-[0.2em]">
                  {frankfurtArticle.eyebrow}
                </span>
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
                Frankfurt Book Fair <span className="text-gold-400">2026</span>
              </h1>
              <p className="text-lg md:text-xl text-cream-100 font-medium mb-5">
                {frankfurtArticle.subtitle}
              </p>
              <p className="text-sm md:text-base text-cream-200/85 leading-relaxed mb-7 max-w-xl">
                {frankfurtArticle.lead}
              </p>

              <div className="flex flex-wrap items-center gap-x-5 gap-y-3 text-xs text-cream-200/80 mb-8">
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line text-gold-400"></i>
                  {frankfurtArticle.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-map-pin-line text-gold-400"></i>
                  {frankfurtArticle.booth}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-gold-400"></i>
                  {frankfurtArticle.readingTime}
                </span>
              </div>

              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                <a
                  href="#the-story"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-semibold text-navy-900 bg-gold-400 rounded-full hover:bg-gold-300 transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  Read the story
                  <i className="ri-arrow-down-line"></i>
                </a>
                <Link
                  to="/contact-us"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm font-medium text-white border border-white/30 rounded-full hover:bg-white/10 hover:border-white/50 transition-all duration-300 hover:scale-105 whitespace-nowrap"
                >
                  Rights enquiries
                </Link>
              </div>
            </div>

            <div className="relative">
              <div className="relative w-full aspect-[4/5] rounded-2xl overflow-hidden border border-white/15">
                <img
                  src={frankfurtArticle.heroImage}
                  alt={frankfurtArticle.heroImageAlt}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-full bg-gold-400 flex items-center justify-center shrink-0">
                    <i className="ri-award-line text-navy-900 text-sm"></i>
                  </div>
                  <p className="text-[11px] text-white/90 leading-snug">
                    Halle 3.1, stand A104 — Messe Frankfurt
                  </p>
                </div>
              </div>

              <div className="hidden md:block absolute -bottom-8 -left-8 w-36 aspect-[3/4] rounded-xl overflow-hidden border-4 border-navy-900">
                <img
                  src={frankfurtArticle.sideImage}
                  alt={frankfurtArticle.sideImageAlt}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="hidden md:flex absolute -top-5 -right-3 items-center gap-2 px-4 py-2 bg-cream-50 rounded-full">
                <i className="ri-check-double-line text-gold-600 text-sm"></i>
                <span className="text-[11px] font-semibold text-navy-900 uppercase tracking-wider whitespace-nowrap">
                  Fair concluded
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}